import { render, staticRenderFns } from "./depositInfoView.vue?vue&type=template&id=b54b8a76&scoped=true&"
import script from "./depositInfoView.vue?vue&type=script&lang=js&"
export * from "./depositInfoView.vue?vue&type=script&lang=js&"
import style0 from "./depositInfoView.vue?vue&type=style&index=0&id=b54b8a76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54b8a76",
  null
  
)

export default component.exports